import { get, post, patch } from 'axios'

// initial state
function initialState() {
  return {
    tickets: undefined,
    selected: {
      ticket: undefined,
      messages: undefined,
    },
  }
}

function newTicket() {
  return {
    isAnonymous: true,
    isMyTicket: true,
    isPositive: undefined,
    isRead: true,
    _id: 'new',
    lastMessage: undefined,
  }
}

const state = initialState()

// getters
const getters = {
  tickets: state => state.tickets,
  selected: state => state.selected,
  unreadTickets: state =>
    state.tickets ? state.tickets.filter(f => !f.isRead).length : 0,
}

// actions
const actions = {
  fetchTickets({ commit }) {
    return get('/tickets?owner=true&status=unread').then(response => {
      commit('setTickets', response.data.tickets)
    })
  },

  selectTicket({ commit }, ticket) {
    commit('setSelectedTicket', ticket)
    commit('setSelectedMessages', undefined)
    if (ticket._id === 'new') {
      commit('setSelectedMessages', [])
    } else {
      return get(`/tickets/${ticket._id}/messages`).then(response => {
        commit('setSelectedMessages', response.data.messages)
      })
    }
  },

  markAsRead({ commit }, ticket) {
    return patch(`/tickets/${ticket._id}`, { isRead: true }).then(() => {
      commit('setRead', ticket._id)
    })
  },

  markAsNotRead({ commit }, ticket) {
    return patch(`/tickets/${ticket._id}`, { isRead: false }).then(() => {
      commit('setNotRead', ticket._id)
    })
  },

  sendMessage({ state, commit }, param) {
    return post(`/tickets/${state.selected.ticket._id}/messages`, {
      message: param.message,
      isAnonymous: param.isAnonymous,
    }).then(response => {
      commit('pushMessage', response.data)
      commit('updateAndSortTicket', response.data)
    })
  },
  sendMessageWithNewTicket({ commit }, param) {
    return post(`/tickets`, {
      message: param.message,
      isAnonymous: param.isAnonymous,
      isPositive: param.isPositive,
    }).then(response => {
      commit('updateTicketWithNew', response.data)
    })
  },
}

// mutations
const mutations = {
  setTickets(state, tickets) {
    state.tickets = tickets
  },
  setRead(state, ticketId) {
    state.tickets.filter(ticket => ticket._id === ticketId)[0].isRead = true
  },
  setNotRead(state, ticketId) {
    state.tickets.filter(ticket => ticket._id === ticketId)[0].isRead = false
  },
  setSelectedTicket(state, ticket) {
    state.selected.ticket = ticket
  },
  pushMessage(state, message) {
    state.selected.messages.push(message)
  },
  setNewTicket(state, values) {
    state.tickets
      .filter(t => t._id === 'new')
      .forEach(t => {
        t[values.prop] = values.value
      })
  },
  createNewTicket(state) {
    if (state.tickets.filter(t => t._id === 'new').length === 0) {
      let newticketobj = newTicket()
      state.tickets.unshift(newticketobj)
      state.selected.ticket = state.tickets[0]
      state.selected.messages = []
    } else {
      state.tickets = state.tickets.filter(t => t._id !== 'new')
      state.selected.ticket = undefined
      state.selected.messages = undefined
    }
  },
  clearNewTicket(state) {
    state.tickets = state.tickets.filter(t => t._id !== 'new')
    state.selected.ticket = undefined
    state.selected.messages = undefined
  },
  clearSelected(state) {
    state.selected.ticket = undefined
    state.selected.messages = undefined
  },
  setSelectedMessages(state, messages) {
    state.selected.messages = messages
  },
  updateTicketWithNew(state, newTicket) {
    state.selected.ticket = Object.assign(state.selected.ticket, newTicket)
    state.selected.ticket = undefined
    state.selected.messages = undefined
  },
  updateAndSortTicket(state, message) {
    let newTickets = state.tickets.filter(
      item => item._id !== state.selected.ticket._id
    )
    state.selected.ticket.lastMessage = message.message
    state.selected.ticket.updatedAt = message.createdAt
    state.selected.ticket.lastReplyAt = message.createdAt
    state.selected.ticket.isAnonymous = message.isAnonymous
    newTickets.unshift(state.selected.ticket)
    state.tickets = newTickets
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
